import {api} from '@/api/index';

import {useQuery} from '@tanstack/react-query';

export const useApiQuery = (
    name: string,
    data: any,
    disabled?: boolean,
) => {
    let queryKey = [];
    let queryFn: () => void;

    // todo? sort cases
    switch (name) {
        case 'getOrder': {
            queryKey = ['order', data.orderId];
            queryFn = () => api.panas.getOrder(data.orderId);

            break;
        }
        case 'getProduct': {
            queryKey = ['product', data.productName, data.currentDate];
            queryFn = () => api.panas.getProduct(data.productName, data.currentDate);

            break;
        }
        case 'getOrders': {
            queryKey = ['orders', data.currentDate, data.showPrevious];
            queryFn = () => api.panas.getOrders(data.currentDate, data.showPrevious);

            break;
        }
        case 'getProducts': {
            queryKey = ['products', data.currentDate];
            queryFn = () => api.panas.getProducts(data.currentDate);

            break;
        }
        case 'getAdditionalPayments': {
            queryKey = ['additionalPayments', data.productName, data.currentDate];
            queryFn = () => api.panas.getAdditionalPayments();

            break;
        }
    }

    return useQuery({
        queryKey,
        queryFn,
        refetchOnWindowFocus: false,
        enabled: !disabled,
    });
};
